import React, { useEffect, useState } from "react"
import { formatDateDataGrid } from "src/utils/format-date"
import PropTypes from 'prop-types'
import dayjs from "dayjs"
import { DATE_FORMAT, DATE_FORMAT_SHOW } from "src/utils/constants"
import DatalakeService from "src/services/datalake-service"
import ParameterPaginationTable from "src/components/table/parameter-pagination-table"

const ParameterPrecosValidacaoPUPARTable = (props) => {
    const datalakeService = new DatalakeService()
    const [data, setData] = useState([])
    const [pagination, setPagination] = useState({ count: 0, next: null, previous: null })

    useEffect(() => {
        loadData()
    }, [])

    const loadData = () => {
        props.loading(true)
        datalakeService.loadPaginationEndpoint(props.endpoint).then((response) => {
            props.loading(false)

            const { body } = response
            const { results, count, next, previous } = body
            const list = results.map((obj) => ({ ...obj, id: obj.ID }))

            setPagination({ count: count, next: next, previous: previous })
            setData(list)
        }).catch((err) => {
            props.loading(false)
            props.callbackError(err)
        }).finally(() => {
            props.loading(false)
        })
    }

    const createRow = async () => {
        const body = {
            "CETIP": "N/A",
            "CNPJ_Securitizador": "N/A",
            "CNPJ_AgenteFiduciario": "N/A",
            "DataReferencia": dayjs().format(DATE_FORMAT),
            "PUPAR_Securitizador": 0,
            "PUPAR_Fiduciario": 0,
            "PUPAR_C2P": 0,
            "DeltaPUPAR_C2P_Fiduciario": 0,
            "DeltaPUPAR_C2P_Securitizador": 0,
            "VarPUPAR_Fiduciario": 0,
            "VarPUPAR_Securitizador": 0,
            "Prioridade_Anterior": 0,
            "Prioridade_Atual": 0,
            "Cliente": "N/A",
            "Observacao": "N/A",
            "Responsavel": "N/A",
            "Status": "N/A",
            "Solicitacao_FINCS": "N/A",
            "Solicitacao_Fiduciario": "N/A",
            "Solicitacao_Securitizador": "N/A",
            "Fonte_Fiduciario": "N/A",
            "Fonte_Securitizador": "N/A",
            "Tipo_Ajuste": "N/A",
            "Fonte_Ajuste": "N/A",
        }

        props.loading(true)
        return datalakeService.createTableEndpoint(props.endpoint, body).then(() => {
            props.loading(false)
            loadData(0, 25)
        }).catch((err) => {
            props.loading(false)
            throw err
        })
    }

    const updateRow = async (newRow) => {
        const { ID, CETIP, CNPJ_Securitizador, CNPJ_AgenteFiduciario,  DataReferencia, PUPAR_Securitizador, PUPAR_Fiduciario, PUPAR_C2P, DeltaPUPAR_C2P_Fiduciario,
            DeltaPUPAR_C2P_Securitizador, VarPUPAR_Fiduciario, VarPUPAR_Securitizador, Prioridade_Anterior, Prioridade_Atual, Cliente, Observacao, Responsavel, Status,
            Solicitacao_FINCS, Solicitacao_Fiduciario, Solicitacao_Securitizador, Fonte_Fiduciario, Fonte_Securitizador, Tipo_Ajuste, Fonte_Ajuste
        } = newRow

        const body = {
            "CETIP": CETIP,
            "CNPJ_Securitizador": CNPJ_Securitizador,
            "CNPJ_AgenteFiduciario": CNPJ_AgenteFiduciario,
            "DataReferencia": DataReferencia,
            "PUPAR_Securitizador": PUPAR_Securitizador,
            "PUPAR_Fiduciario": PUPAR_Fiduciario,
            "PUPAR_C2P": PUPAR_C2P,
            "DeltaPUPAR_C2P_Fiduciario": DeltaPUPAR_C2P_Fiduciario,
            "DeltaPUPAR_C2P_Securitizador": DeltaPUPAR_C2P_Securitizador,
            "VarPUPAR_Fiduciario": VarPUPAR_Fiduciario,
            "VarPUPAR_Securitizador": VarPUPAR_Securitizador,
            "Prioridade_Anterior": Prioridade_Anterior,
            "Prioridade_Atual": Prioridade_Atual,
            "Cliente": Cliente,
            "Observacao": Observacao,
            "Responsavel": Responsavel,
            "Status": Status,
            "Solicitacao_FINCS": Solicitacao_FINCS,
            "Solicitacao_Fiduciario": Solicitacao_Fiduciario,
            "Solicitacao_Securitizador": Solicitacao_Securitizador,
            "Fonte_Fiduciario": Fonte_Fiduciario,
            "Fonte_Securitizador": Fonte_Securitizador,
            "Tipo_Ajuste": Tipo_Ajuste,
            "Fonte_Ajuste": Fonte_Ajuste,
        }

        props.loading(true)
        return datalakeService.updateTableEndpoint(props.endpoint, ID, body).then(() => {
            
            props.loading(false)
        }).catch((err) => {
            props.loading(false)
            throw err
        })
    }

    const deleteRow = async (row) => {
        props.loading(true)
        const { ID } = row
        return datalakeService.deleteTableEndpoint(props.endpoint, ID).then(() => {
            props.loading(false)
            const listRemoved = data.filter((item) => item.ID !== ID)
            setData(listRemoved)
        }).catch((err) => {
            props.loading(false)
            throw err
        })
    }


    const onFilter = async (filterList, limit, offset) => {
        const query = filterList.map(obj => `${encodeURIComponent(obj.field)}=${encodeURIComponent(obj.value)}`).join('&')

        props.loading(true)
        datalakeService.loadPaginationEndpoint(props.endpoint, query, limit, offset).then((response) => {
            props.loading(false)
            const { body } = response
            const { results, count, next, previous } = body
            const list = results.map((obj) => ({ ...obj, id: obj.ID }))
            setPagination({ count: count, next: next, previous: previous })
            setData(list)
        })
    }

    const changePage = async (endpoint) => {
        props.loading(true)
        datalakeService.paginate(endpoint).then((response) => {
            props.loading(false)
            const { body } = response
            const { results, count, previous, next } = body
            const list = results.map((obj) => ({ ...obj, id: obj.ID }))

            setPagination({ count: count, next: next, previous: previous })
            setData([])
            setData(list)
        })
    }

    const columns = [
        {
            field: 'ID',
            headerName: '#',
            disableColumnMenu: true,
            disableFilter: true,
            flex: true,
            minWidth: 80,
        },
        {
            field: 'CETIP',
            headerName: 'CETIP',
            flex: 1,
            minWidth: 150,
            maxWidth: 350,
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'CNPJ_Securitizador',
            headerName: 'CNPJ_Securitizador',
            flex: 1,
            minWidth: 150,
            maxWidth: 350,
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'CNPJ_AgenteFiduciario',
            headerName: 'CNPJ_AgenteFiduciario',
            flex: 1,
            minWidth: 150,
            maxWidth: 350,
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'DataReferencia',
            headerName: 'DataReferencia',
            flex: 1,
            minWidth: 150,
            maxWidth: 350,
            typeComponent: 'date',
            disableColumnMenu: true,
            editable: true,
            renderCell: (params) => {
                if (!params.value) {
                    return ''
                } 
                return dayjs(params.value).format(DATE_FORMAT_SHOW)
            }
        },
        {
            field: 'PUPAR_Securitizador',
            headerName: 'PUPAR_Securitizador',
            flex: 1,
            minWidth: 150,
            maxWidth: 350,
            typeComponent: 'number',
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'PUPAR_Fiduciario',
            headerName: 'PUPAR_Fiduciario',
            flex: 1,
            minWidth: 150,
            maxWidth: 350,
            typeComponent: 'number',
            type: 'number',
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'PUPAR_C2P',
            headerName: 'PUPAR_C2P',
            flex: 1,
            minWidth: 150,
            maxWidth: 350,
            typeComponent: 'number',
            type: 'number',
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'DeltaPUPAR_C2P_Fiduciario',
            headerName: 'DeltaPUPAR_C2P_Fiduciario',
            flex: 1,
            minWidth: 150,
            maxWidth: 350,
            typeComponent: 'number',
            type: 'number',
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'DeltaPUPAR_C2P_Securitizador',
            headerName: 'DeltaPUPAR_C2P_Securitizador',
            flex: 1,
            minWidth: 150,
            maxWidth: 350,
            typeComponent: 'number',
            type: 'number',
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'VarPUPAR_Fiduciario',
            headerName: 'VarPUPAR_Fiduciario',
            flex: 1,
            minWidth: 150,
            maxWidth: 350,
            typeComponent: 'number',
            type: 'number',
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'VarPUPAR_Securitizador',
            headerName: 'VarPUPAR_Securitizador',
            flex: 1,
            minWidth: 150,
            maxWidth: 350,
            disableColumnMenu: true,
            typeComponent: 'number',
            type: 'number',
            editable: true
        },
        {
            field: 'Prioridade_Anterior',
            headerName: 'Prioridade_Anterior',
            flex: 1,
            minWidth: 150,
            maxWidth: 350,
            typeComponent: 'number',
            type: 'number',
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'Prioridade_Atual',
            headerName: 'Prioridade_Atual',
            flex: 1,
            minWidth: 150,
            maxWidth: 350,
            typeComponent: 'number',
            type: 'number',
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'Cliente',
            headerName: 'Cliente',
            flex: 1,
            minWidth: 150,
            maxWidth: 350,
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'Observacao',
            headerName: 'Observacao',
            flex: 1,
            minWidth: 150,
            maxWidth: 350,
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'Responsavel',
            headerName: 'Responsavel',
            flex: 1,
            minWidth: 150,
            maxWidth: 350,
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'Status',
            headerName: 'Status',
            flex: 1,
            minWidth: 150,
            maxWidth: 350,
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'Solicitacao_FINCS',
            headerName: 'Solicitacao_FINCS',
            flex: 1,
            minWidth: 150,
            maxWidth: 350,
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'Solicitacao_Fiduciario',
            headerName: 'Solicitacao_Fiduciario',
            flex: 1,
            minWidth: 150,
            maxWidth: 350,
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'Solicitacao_Securitizador',
            headerName: 'Solicitacao_Securitizador',
            flex: 1,
            minWidth: 150,
            maxWidth: 350,
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'Fonte_Fiduciario',
            headerName: 'Fonte_Fiduciario',
            flex: 1,
            minWidth: 150,
            maxWidth: 350,
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'Fonte_Securitizador',
            headerName: 'Fonte_Securitizador',
            flex: 1,
            minWidth: 150,
            maxWidth: 350,
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'Tipo_Ajuste',
            headerName: 'Tipo_Ajuste',
            flex: 1,
            minWidth: 150,
            maxWidth: 350,
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'Fonte_Ajuste',
            headerName: 'Fonte_Ajuste',
            flex: 1,
            minWidth: 150,
            maxWidth: 350,
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'CriadoEm',
            headerName: 'Data de Criação',
            flex: true,
            minWidth: 150,
            disableColumnMenu: true,
            disableFilter: true,
            renderCell: (params) => formatDateDataGrid(params)
        },
        {
            field: 'AtualizadoEm',
            headerName: 'Data de Atualização',
            flex: true,
            minWidth: 150,
            disableColumnMenu: true,
            disableFilter: true,
            renderCell: (params) => formatDateDataGrid(params)
        }
    ]

    return (
        <div>
            <ParameterPaginationTable
                columns={columns}
                data={data}
                setData={setData}
                createRow={createRow}
                deleteRow={deleteRow}
                updateRow={updateRow}
                pagination={pagination}
                onChangePage={changePage}
                filterFunction={onFilter}
                customFilter={true} />
        </div>
    )
}

ParameterPrecosValidacaoPUPARTable.propTypes = {
    loading: PropTypes.func,
    endpoint: PropTypes.string,
    callbackError: PropTypes.func
}

export default ParameterPrecosValidacaoPUPARTable